import { render, staticRenderFns } from "./ItemsListComponent.vue?vue&type=template&id=96656a26&scoped=true&"
import script from "./ItemsListComponent.vue?vue&type=script&lang=js&"
export * from "./ItemsListComponent.vue?vue&type=script&lang=js&"
import style0 from "./ItemsListComponent.vue?vue&type=style&index=0&id=96656a26&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96656a26",
  null
  
)

export default component.exports